import React from 'react';
import moment from 'moment-timezone';
import Modal from '../../commons/modal/modal';
import styles from './ceTaskboard.scss';
import { getFormattedDateAndTime } from '../../../services/helpers';
import {
  isAppointmentDelivery,
  deliveryTypeList,
  isStatusPending,
  deliveryClientList
} from '../../helper/DeliveryTypeHelper';
import {
  defaultPODetail,
  isPoDetailsRequired
} from '../../helper/PurchaseOrderHelper';
import DatePicker from '../../commons/datePicker/datePicker';
import InputField from '../../commons/formElements/inputField/inputField';
import {
  getAdHolidayDate,
  getConsignmentAppointmentDetails
} from './ceTaskboardRedux/ceTaskboardActionCreator';
import BasicSelect from '../../commons/formElements/basicSelect/basicSelect';

const addIcon = require('../../../assets/images/add_button_dark_green_icn.svg');
const closeIcon = require('../../../assets/images/close_icn.svg');

class CreateNewAppointmentTaskModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      cnote: '',
      excludeTimes: [],
      holidayMsg: ''
    };
    this.onClose = this.onClose.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.rowData !== this.props.rowData) {
      this.setState(prevState => {
        return {
          data: Object.assign({}, prevState.data, nextProps.rowData)
        };
      });
    }
  }

  onCnoteChange(cnote) {
    this.setState({
      cnote
    });
  }

  onCnoteKeyPress(event) {
    if (event.key === 'Enter') {
      getConsignmentAppointmentDetails(this.state.cnote, data =>
        this.setState({ data }, () => {
          this.props.getPoDetailsByConsignmentId(this.state.data.id);
        })
      );
    }
  }

  onAppointmentIdChange(appointmentId) {
    this.setState({ data: Object.assign(this.state.data, { appointmentId }) });
  }

  generateExcludeTimes = () => {
    const excludeTimes = [];

    // Create a moment object for the specific time (current time)
    const specificTime = moment().set({
      hour: moment().hour(),
      minute: moment().minute(),
      second: 0,
      millisecond: 0
    });
    // Initialize timeSlot to start from the beginning of the day
    let timeSlot = moment().startOf('day');

    // Continue adding time slots until we reach or exceed the specificTime
    while (timeSlot.isBefore(specificTime)) {
      excludeTimes.push(timeSlot.toDate()); // Add the time slot to excludeTimes as a Date object
      timeSlot.add(1, 'minute'); // Increment by 1 minute
    }

    return excludeTimes;
  };

  onAppointmentTimeChange(appointmentTimeMoment) {
    const selectedTimeStamp = moment(appointmentTimeMoment)
      .clone()
      .tz('Asia/Kolkata')
      .startOf('day')
      .valueOf();
    const currentTimestamp = moment()
      .tz('Asia/Kolkata')
      .startOf('day')
      .valueOf();

    const excludeTimes =
      selectedTimeStamp === currentTimestamp &&
      (this.state.data.minimumDeliveryDateTime ||
        !this.state.data.appointmentDeliveryMinLimit)
        ? this.generateExcludeTimes()
        : [];

    this.setState({
      data: Object.assign(this.state.data, {
        appointmentTime: appointmentTimeMoment.valueOf()
      }),
      excludeTimes: excludeTimes
    });
  }

  onDeliveryTypeChange(deliveryType) {
    // in case delivery type is APPOINTMENT, then we don't send the delivery client
    // hence we set is as null over here
    this.setState({
      data: Object.assign(this.state.data, {
        deliveryType,
        deliveryClient: null
      })
    });
  }

  onDeliveryClientChange(deliveryClient) {
    this.setState({
      data: Object.assign(this.state.data, {
        deliveryClient,
        fcName: null,
        purchaseOrderDTOs: [{ ...defaultPODetail }]
      })
    });
  }

  onClose() {
    this.props.closeModal();
    this.setState({
      cnote: '',
      data: this.props.rowData
    });
  }

  onFcNameSelect(val: string) {
    if (val) {
      this.setState({
        data: Object.assign(this.state.data, {
          fcName: val
        })
      });
    }
  }

  addPoDetail() {
    this.setState(prevState => {
      const poDtos = [...prevState.data.purchaseOrderDTOs];
      poDtos.push({ ...defaultPODetail });
      return {
        data: Object.assign(prevState.data, {
          purchaseOrderDTOs: [...poDtos]
        })
      };
    });
  }

  deletePoDetail(index) {
    this.setState(prevState => {
      const poDtos = [...prevState.data.purchaseOrderDTOs];
      poDtos.splice(index, 1);
      return {
        data: Object.assign(prevState.data, {
          purchaseOrderDTOs: [...poDtos]
        })
      };
    });
  }

  onPoDetailsChange(val, index, field) {
    this.setState(prevState => {
      const poDtos = [...prevState.data.purchaseOrderDTOs];
      switch (field) {
        case 'po':
          poDtos[index].po = val;
          break;
        case 'units':
          poDtos[index].units = val;
          break;
        case 'poExpiryTime':
          poDtos[index].poExpiryTime = val.valueOf();
          break;
      }
      return {
        data: Object.assign(prevState.data, {
          purchaseOrderDTOs: [...poDtos]
        })
      };
    });
  }

  didPoDetailsNeedToRender() {
    return (
      isAppointmentDelivery(this.state.data.deliveryType) &&
      this.props.isPoDetailsLoading === false &&
      this.state.data.purchaseOrderDTOs &&
      !!this.state.data.purchaseOrderDTOs.length
    );
  }

  checkAdDateHoliday(date, toPinCode) {
    getAdHolidayDate(
      {
        appointmentDateTime: moment(date).valueOf(),
        toPinCode
      },
      res => {
        this.setState({ holidayMsg: res.payload });
      },
      () => {
        this.setState({ holidayMsg: '' });
      }
    );
  }

  render() {
    const isDeliveryFieldsEditable =
      this.props.rowData && this.props.rowData.appointmentStatus
        ? isStatusPending(this.props.rowData.appointmentStatus)
        : true;
    const fcNameOptions =
      isPoDetailsRequired(this.state.data.deliveryClient) &&
      this.state.data.fcNameHash
        ? this.state.data.fcNameHash[
            this.state.data.deliveryClient.toUpperCase()
          ]
        : [];

    return (
      <Modal
        showModal={this.props.showModal}
        title={
          this.state.data.cnote
            ? `CN# ${this.state.data.cnote}`
            : 'Create New Task'
        }
        closeModal={() => {
          this.setState({ holidayMsg: '' });
          this.onClose();
        }}
        modalTheme={{
          name: 'themeGreyLarge'
        }}
      >
        <div
          className={`l-col ${styles.modalContentWrapper}`}
          style={{ paddingBottom: '0' }}
        >
          {this.state.data.cnote ? (
            <div className={`flex-100 ${styles.modalBody}`}>
              <div className={`l-row j-space-bet ${styles.modalRow}`}>
                <div className="flex-30">
                  <div className={styles.smallText}>Client (Code)</div>
                  <div className={styles.text}>
                    {`${this.state.data.clientName} (${this.state.data.clientCode})`}
                  </div>
                </div>
                <div className="flex-30">
                  <div className={styles.smallText}>Consignor Details</div>
                  <div className={styles.text}>
                    {this.state.data.consignorName}
                  </div>
                </div>
                <div className="flex-30">
                  <div className={styles.smallText}>Consignee Details</div>
                  <div className={styles.text}>
                    {this.state.data.consigneeName}
                  </div>
                </div>
              </div>
              <div className={`l-row j-space-bet ${styles.modalRow}`}>
                <div className="flex-30">
                  <div className={styles.smallText}>Booking Date and Time</div>
                  <div className={styles.text}>
                    {getFormattedDateAndTime(this.state.data.bookingDateTime)}
                  </div>
                </div>
                <div className="flex-30">
                  <div className={styles.smallText}>EDD</div>
                  <div className={styles.text}>
                    {this.state.data && this.state.data.edd
                      ? getFormattedDateAndTime(this.state.data.edd)
                      : '--'}
                  </div>
                </div>
                <div className="flex-30">
                  <div className={styles.smallText}>CPD</div>
                  <div className={styles.text}>
                    {this.state.data.promisedDeliveryDateTime
                      ? getFormattedDateAndTime(
                          // this.state.data.minimumDeliveryDateTime ||
                          this.state.data.promisedDeliveryDateTime
                        )
                      : '-'}
                  </div>
                </div>
              </div>
              <div className={`l-row j-space-bet ${styles.modalRow}`}>
                <div className="flex-30">
                  <div className={styles.smallText}>Delivery Type</div>
                  {isDeliveryFieldsEditable ? (
                    <BasicSelect
                      label="Select Delivery Type"
                      selectedOpt={this.state.data.deliveryType}
                      optionsArrOfObj={deliveryTypeList}
                      onSelect={value => {
                        this.onDeliveryTypeChange(value);
                      }}
                    />
                  ) : (
                    <div className={styles.text}>
                      {this.state.data.deliveryType}
                    </div>
                  )}
                </div>
                {this.state.data &&
                this.state.data.deliveryType === 'APPOINTMENT' ? (
                  <div className="flex-30">
                    <div className={styles.smallText}>Delivery Client</div>
                    {isDeliveryFieldsEditable ? (
                      <BasicSelect
                        label="Select Delivery Client"
                        selectedOpt={this.state.data.deliveryClient}
                        optionsArrOfObj={deliveryClientList}
                        onSelect={value => {
                          this.onDeliveryClientChange(value);
                        }}
                        disableNone={true}
                      />
                    ) : (
                      <div className={styles.text}>
                        {this.state.data.deliveryClient}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="flex-30" />
                )}
                <div className="flex-30" />
              </div>
              <div className={`l-row j-space-bet ${styles.modalRow}`}>
                {isAppointmentDelivery(this.state.data.deliveryType) && (
                  <React.Fragment>
                    <div className="flex-30">
                      <div className={styles.smallText}>
                        Appointment ID / PO Number
                      </div>
                      <div className={styles.text}>
                        <InputField
                          maxLength="255"
                          placeholder="Enter Appointment ID / PO Number"
                          type="text"
                          value={this.state.data.appointmentId}
                          onChange={val => this.onAppointmentIdChange(val)}
                        />
                      </div>
                    </div>
                    <div className="flex-30">
                      <div className={styles.smallText}>Appointment Time</div>
                      <DatePicker
                        name="Appointment Time"
                        startDate={
                          this.state.data.appointmentTime &&
                          new Date(this.state.data.appointmentTime)
                        }
                        onChange={val => {
                          if (
                            this.state.data &&
                            this.state.data.toPinCode &&
                            val
                          ) {
                            this.checkAdDateHoliday(
                              val,
                              this.state.data.toPinCode
                            );
                          }
                          this.onAppointmentTimeChange(val);
                        }}
                        placeholderText="Appointment Time"
                        showTimeSelect={true}
                        timeFormat="hh:mm aa"
                        dateFormat="MMM dd, yyyy hh:mm aa"
                        minDate={
                          this.state.data.minimumDeliveryDateTime &&
                          this.state.data.appointmentDeliveryMinLimit
                            ? moment(this.state.data.minimumDeliveryDateTime)
                                .add(
                                  this.state.data.appointmentDeliveryMinLimit,
                                  'days'
                                )
                                .startOf('day')
                                .toDate()
                            : new Date()
                        }
                        maxDate={
                          this.state.data.minimumDeliveryDateTime &&
                          this.state.data.appointmentDeliveryMaxLimit
                            ? moment(this.state.data.minimumDeliveryDateTime)
                                .add(
                                  this.state.data.appointmentDeliveryMaxLimit,
                                  'days'
                                )
                                .endOf('day')
                                .toDate()
                            : null
                        }
                        {...(this.state.data.appointmentTime && {
                          excludeTimes: this.state.excludeTimes
                        })}
                        className="prq-date-picker no-margin"
                      />
                      {!!this.state.holidayMsg && (
                        <div className={styles.adHolidayDate}>
                          The AD date selected is{' '}
                          <span style={{ fontWeight: 'bold' }}>
                            {this.state.holidayMsg}
                          </span>{' '}
                          in the Delivery location
                        </div>
                      )}
                    </div>
                    <div className="flex-30" />
                  </React.Fragment>
                )}
              </div>
              {this.didPoDetailsNeedToRender() &&
                isPoDetailsRequired(this.state.data.deliveryClient) && (
                  <div className={`l-row j-space-bet ${styles.modalRow}`}>
                    <div className="flex-30">
                      <div className={styles.smallText}>FC Name</div>
                      {isDeliveryFieldsEditable ? (
                        <BasicSelect
                          label="Select FC Name"
                          selectedOpt={this.state.data.fcName}
                          optionsArrOfObj={fcNameOptions}
                          onSelect={value => {
                            this.onFcNameSelect(value);
                          }}
                          disableNone={true}
                        />
                      ) : (
                        <div className={styles.text}>
                          {this.state.data.deliveryType}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              {this.didPoDetailsNeedToRender() &&
                Array.isArray(this.state.data.purchaseOrderDTOs) &&
                this.state.data.purchaseOrderDTOs.map((poDetail, index) => (
                  <div
                    key={index}
                    className={`l-row j-space-bet ${styles.modalRow}`}
                  >
                    <div className="flex-25">
                      <div className={styles.smallText}>PO Number</div>
                      {isDeliveryFieldsEditable ? (
                        <div className={styles.text}>
                          <InputField
                            maxLength="255"
                            placeholder="Enter PO Number"
                            type="text"
                            value={poDetail.po}
                            onChange={val =>
                              this.onPoDetailsChange(val, index, 'po')
                            }
                          />
                        </div>
                      ) : (
                        <div className={styles.text}>{poDetail.po}</div>
                      )}
                    </div>
                    <div className="flex-25">
                      <div className={styles.smallText}>No. of Units</div>
                      {isDeliveryFieldsEditable ? (
                        <div className={styles.text}>
                          <InputField
                            maxLength="255"
                            placeholder="Enter No of Units"
                            type="text"
                            allowedInputKeys="onlynumber"
                            value={String(poDetail.units)}
                            onChange={val =>
                              this.onPoDetailsChange(val, index, 'units')
                            }
                          />
                        </div>
                      ) : (
                        <div className={styles.text}>{poDetail.units}</div>
                      )}
                    </div>
                    <div className="flex-30">
                      <div className={styles.smallText}>Expiry Date</div>
                      {isDeliveryFieldsEditable ? (
                        <div className={styles.text}>
                          <DatePicker
                            name="Enter Expiry Date"
                            startDate={
                              poDetail.poExpiryTime &&
                              new Date(poDetail.poExpiryTime)
                            }
                            onChange={val =>
                              this.onPoDetailsChange(val, index, 'poExpiryTime')
                            }
                            placeholderText="Expiry Time"
                            showTimeSelect={true}
                            timeFormat="hh:mm aa"
                            dateFormat="MMM dd, yyyy hh:mm aa"
                            minDate={new Date()}
                            className="prq-date-picker no-margin"
                          />
                        </div>
                      ) : (
                        <div className={styles.text}>
                          {poDetail.poExpiryTime
                            ? getFormattedDateAndTime(poDetail.poExpiryTime)
                            : '--'}
                        </div>
                      )}
                    </div>
                    {isDeliveryFieldsEditable && (
                      <div className="flex-10">
                        {index === 0 ? (
                          <button
                            className={styles.addPoButton}
                            onClick={e => this.addPoDetail()}
                          >
                            <img src={addIcon} />
                          </button>
                        ) : (
                          <button
                            className={styles.addPoButton}
                            onClick={e => this.deletePoDetail(index)}
                          >
                            <img src={closeIcon} />
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                ))}
            </div>
          ) : (
            <div className={`flex-100 ${styles.modalBody}`}>
              <InputField
                maxLength="10"
                allowedInputKeys="onlynumber"
                placeholder="Enter Consignment No."
                type="text"
                value={this.state.cnote}
                onChange={val => this.onCnoteChange(val)}
                onKeyPress={event => this.onCnoteKeyPress(event)}
              />
            </div>
          )}
          <div className="l-row j-end a-end">
            <div
              className={`${styles.submitBtnWrapper} l-row j-center a-center ${
                this.props.isSubmitButtonDisabled ? styles.disabledButton : ''
              }`}
              style={{ marginBottom: '2rem' }}
              onClick={() => {
                if (!this.props.isSubmitButtonDisabled) {
                  this.props.scheduleTask(
                    this.state.data,
                    this.onClose,
                    isDeliveryFieldsEditable
                  );
                }
              }}
            >
              SUBMIT
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
export default CreateNewAppointmentTaskModal;
